/**
 * Typography Tokens - Fonts, sizes, weights, and line heights
 */

export const typography = {
  fonts: {
    main: { value: 'Montserrat, sans-serif' },
    body: { value: 'Lato, sans-serif' },
  },
  fontSizes: {
    '3xl': { value: '26px' },
    '2xl': { value: '22px' },
    xl: { value: '20px' },
    l: { value: '18px' },
    m: { value: '16px' },
    s: { value: '14px' },
    xs: { value: '12px' },
  },
  fontWeights: {
    regular: { value: '400' },
    medium: { value: '500' },
    semibold: { value: '600' },
  },
  lineHeights: {
    120: { value: '120%' },
    130: { value: '130%' },
    140: { value: '140%' },
  },
  letterSpacings: {
    none: { value: '0px' },
  },
};
